
import React, { useEffect } from "react";
import { X, CheckCircle, AlertCircle, AlertTriangle } from "lucide-react";

const Toast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  // Set styles based on type
  let bgColor, textColor, borderColor, Icon;

  switch (type) {
    case "error":
      bgColor = "bg-red-100";
      textColor = "text-red-800";
      borderColor = "border-red-200";
      Icon = AlertCircle;
      break;
    case "warning":
      bgColor = "bg-yellow-100";
      textColor = "text-yellow-800";
      borderColor = "border-yellow-200";
      Icon = AlertTriangle;
      break;
    case "success":
    default:
      bgColor = "bg-green-100";
      textColor = "text-green-800";
      borderColor = "border-green-200";
      Icon = CheckCircle;
  }

  return (
    <div
      className={`fixed top-4 right-4 z-50 p-4 rounded-md shadow-lg border ${bgColor} ${borderColor}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Icon className={`mr-2 h-5 w-5 ${textColor}`} />
          <span className={`${textColor} font-medium`}>{message}</span>
        </div>
        <button
          onClick={onClose}
          className={`ml-4 ${textColor} hover:opacity-75`}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
